import Metis from "../metis";
import {escapeMetisVariables, unescapeMetisReturnObject} from "./escapeMetis";

const metis = new Metis();
const wp = wp_metis;
class MerkListe {
  /**
   * Adds a course to a watch list.
   * If no watch list key is given, a new watch list will be created.
   * A maximum of 30 courses can be added to a watch list.
   *
   * @param {string} merklisteKey
   * @param {string} kursnr
   * @returns {Object} merkliste
   */
  async addKursToGuestMerkliste(kursnr = '', merklisteKey) {

    const queryString = `mandantennummer: ${wp.mandantennummer}${merklisteKey ? (', merklisteKey: "' + merklisteKey + '"') : ''}${kursnr != '' ? ', kursnr: "' + kursnr + '"' : '' }`;
    // console.log('queryString ', queryString);

    const request = metis.metisRequest({
      query: `
      mutation {
        addKursToGuestMerkliste(${queryString}) {
          merklisteKey
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.addKursToGuestMerkliste;
    }
  }

  /**
   * Adds a course to a profile watchlist.
   * If there is no watch list for the profile, a new watch list is created.
   * A maximum of 30 courses can be added to a watch list. (protected)
   *
   * @param {string} kursnr
   * @returns {Object} merkliste
   */
  async addKursToProfilMerkliste(kursnr) {
    const request = metis.metisRequest({
      query: `
        mutation {
            addKursToProfilMerkliste(mandantennummer: ${wp.mandantennummer}, kursnr: "${kursnr}") {
            merklisteKey
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.addKursToProfilMerkliste;
    }
  }

  /**
   * Deletes a course from the watch list,
   * if the watch list is empty, zero is returned.
   *
   * @param {String} merklisteKey
   * @param {String} kursnr
   */
  async deleteKursFromGuestMerkliste(merklisteKey, kursnr) {
    const request = metis.metisRequest({
      query: `
        mutation {
            deleteKursFromGuestMerkliste(mandantennummer: ${wp.mandantennummer}, merklisteKey: "${merklisteKey}", kursnr: "${kursnr}")
        }`,
    });
    const response = await request;

      if (response) {
        return response.deleteKursFromGuestMerkliste;
      }
  }

   /**
   * Deletes a course from the watch list,
   * if the watch list is empty, zero is returned.
   *
   * @param {String} merklisteKey
   * @param {String} kursnr
   */
    async deleteKursFromProfilMerkliste(merklisteKey, kursnr) {
      const request = metis.metisRequest({
        query: `
          mutation {
            deleteKursFromProfilMerkliste(mandantennummer: ${wp.mandantennummer}, merklisteKey: "${merklisteKey}", kursnr: "${kursnr}")
          }`,
      });
      const response = await request;

      if (response) {
        return response.deleteKursFromProfilMerkliste;
      }
    }

  async addGuestMerklisteToProfilMerkliste(merklisteKey) {
    const request = metis.metisRequest({
      query: `
      mutation {
        addGuestMerklisteToProfilMerkliste(merklisteKey: "${merklisteKey}") {
          merklisteKey
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.addGuestMerklisteToProfilMerkliste;
    }
  }

  async getGuestMerkliste(merklisteKey) {
    const request = metis.metisRequest({
      query: `
        query {
            getGuestMerkliste(merklisteKey: "${merklisteKey}") {
              merklisteKey
              kurse {
                kurs {
                  kursnr
                  kursart {
                    bezeichnung
                  }
                  kursOnline {
                    anmeldeschluss
                    onlineBezeichnung
                    sachbearbeiter
                    stichworte
                    begrenzungsdat
                    ratenzahlung
                    anzDozenten
                    anzStdplan
                    anzVeroeff
                    anzTln
                    anzKlassenbuch
                    anzChat
                    kursBuchbar
                    wartelisteBuchbar
                    frageantln
                    neuerkurs
                    kategorieunter
                    trackingcode
                    anzWarteliste
                    dozTerminabfrageVon
                    dozTerminabfrageBis
                    icon {
                      bezeichnung
                      altText
                      url
                    }
                  }
                  afg
                  akten
                  anfang
                  anztln
                  anzvorm
                  ende
                  kursbez
                  maxtln
                  mintln
                  planung
                  preis
                  sachbearb
                  stornotag
                  stunden
                  teilnehmer
                  termine
                  onlineanteil
                  firmenseminar
                  fruehbucher
                  anmeldeschluss
                  abBez
                  abArt
                  preisRabatt
                  keinelastschrift
                  aktiv
                  beliebtheit
                  foerderfaehig
                  dauer
                }
              }
            }
          }`,
    });

    const response = await request;

    if (response) {
      return response.getGuestMerkliste;
    }
  }

  async getProfilMerkliste() {
    const request = metis.metisRequest({
      query: `
        query {
            getProfilMerkliste {
              merklisteKey
              kurse {
                kurs {
                  kursnr
                  kursart {
                    bezeichnung
                  }
                  kursOnline {
                    anmeldeschluss
                    onlineBezeichnung
                    sachbearbeiter
                    stichworte
                    begrenzungsdat
                    ratenzahlung
                    anzDozenten
                    anzStdplan
                    anzVeroeff
                    anzTln
                    anzKlassenbuch
                    anzChat
                    kursBuchbar
                    wartelisteBuchbar
                    frageantln
                    neuerkurs
                    kategorieunter
                    trackingcode
                    anzWarteliste
                    dozTerminabfrageVon
                    dozTerminabfrageBis
                    icon {
                      bezeichnung
                      altText
                      url
                    }
                  }
                  produkt {
                    produktnr
                  }
                  afg
                  akten
                  anfang
                  anztln
                  anzvorm
                  ende
                  kursbez
                  maxtln
                  mintln
                  planung
                  preis
                  sachbearb
                  stornotag
                  stunden
                  teilnehmer
                  termine
                  onlineanteil
                  firmenseminar
                  fruehbucher
                  anmeldeschluss
                  abBez
                  abArt
                  preisRabatt
                  keinelastschrift
                  aktiv
                  beliebtheit
                  foerderfaehig
                  dauer
                }
              }
            }
          }`,
    });

    const response = await request;

    if (response) {
      return response.getProfilMerkliste;
    }
  }
}

export default MerkListe;
